import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ForeignAttribute  {
    _originalTypeClassName = "zERP.BO.ForeignAttribute";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ForeignAttribute.translate = translateService;
}
this.ClsAttributeEnumValue = [];
this.Id = null;
this.AttributeName = null;
this.Values = null;
this.StartDate = null;
this.Reason = null;
this.DataType = null;
this.Description = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
AttributeName:any;
Values:any;
StartDate:any;
Reason:any;
DataType:any;
Description:any;
ClsAttributeEnumValue:any;
AttributeEnumValue:any;
GroupName:any;
static setClsAttributeEnumValue = ($this, items) => {
                if (items == null) items = [];
                if ($this.ClsAttributeEnumValue == null) $this.ClsAttributeEnumValue = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ClsAttributeEnumValue.length > 0) {
                    Domain.ForeignAttribute.removeClsAttributeEnumValue($this, $this.ClsAttributeEnumValue[0]);
                }

                Domain.ForeignAttribute.addManyClsAttributeEnumValue($this, copyItems);
            }
static addManyClsAttributeEnumValue = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ForeignAttribute.addClsAttributeEnumValue($this, items[i]);
                }
            }
static addClsAttributeEnumValue = ($this, item) => {
                if ($this.ClsAttributeEnumValue == null) $this.ClsAttributeEnumValue = [];
                if (item == null || $this.ClsAttributeEnumValue.indexOf(item) > -1) return;
                $this.ClsAttributeEnumValue.push(item);
if (item.ForeignAttribute != $this) {
Domain.AttributeEnumValue.setForeignAttribute(item, $this);
}
}
static addRangeClsAttributeEnumValue = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ForeignAttribute.addClsAttributeEnumValue($this, item));
            }
static removeClsAttributeEnumValue = ($this, item) => {
                if ($this == null || $this.ClsAttributeEnumValue == null || $this.ClsAttributeEnumValue.indexOf(item) === -1) return;
                var _index = $this.ClsAttributeEnumValue.indexOf(item);
                $this.ClsAttributeEnumValue.splice(_index, 1);
item.ForeignAttribute = null;
}
static clearClsAttributeEnumValue = ($this) => { $this.ClsAttributeEnumValue = null; }
static setAttributeEnumValue = ($this, value) => {
var oldValue = $this.AttributeEnumValue;
$this.AttributeEnumValue = value;
if (value != null) {
}
}
static setGroupName = ($this, value) => {
var oldValue = $this.GroupName;
$this.GroupName = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}